(() => {
  const rootPath = () => {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    return '/';
  };

  const changeQuantity = async (line, quantity, control) => {
    const next = Math.max(0, Number(quantity) || 0);
    if (control) control.disabled = true;
    try {
      const response = await fetch(`${rootPath()}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: next })
      });
      if (!response.ok) throw new Error('cart_change_failed');
      window.location.reload();
    } catch (_) {
      if (control) control.disabled = false;
    }
  };

  document.addEventListener('click', (event) => {
    const qtyButton = event.target.closest('[data-oss-qty-change]');
    if (qtyButton) {
      event.preventDefault();
      const line = qtyButton.dataset.line;
      const item = qtyButton.closest('[data-line]');
      const input = item && item.querySelector('[data-oss-qty-input]');
      if (!input) return;
      const step = Number(qtyButton.dataset.ossQtyChange) || 0;
      const max = input.max ? Number(input.max) : Infinity;
      const next = Math.min(max, Math.max(1, Number(input.value || 1) + step));
      if (next === Number(input.value)) return;
      input.value = next;
      changeQuantity(line, next, qtyButton);
      return;
    }

    const discountButton = event.target.closest('[data-oss-discount-apply]');
    if (discountButton) {
      event.preventDefault();
      const wrap = discountButton.closest('[data-oss-code]');
      const input = wrap && wrap.querySelector('[data-oss-discount-input]');
      const message = wrap && wrap.querySelector('[data-oss-discount-message]');
      const code = input ? input.value.trim() : '';
      if (!code) {
        if (message) message.textContent = 'Enter a discount code first.';
        if (input) input.focus();
        return;
      }
      discountButton.disabled = true;
      if (message) message.textContent = 'Applying code…';
      const redirect = encodeURIComponent(`${rootPath()}cart`);
      window.location.assign(`${rootPath()}discount/${encodeURIComponent(code)}?redirect=${redirect}`);
      return;
    }

    const addButton = event.target.closest('[data-oss-quick-add]');
    if (addButton) {
      event.preventDefault();
      const card = addButton.closest('[data-oss-rec-card]');
      const select = card && card.querySelector('[data-oss-rec-variant]');
      const status = card && card.querySelector('[data-oss-rec-status]');
      const variantId = select && Number(select.value);
      if (!variantId) {
        if (status) status.textContent = 'Please select a size.';
        return;
      }
      addButton.disabled = true;
      if (status) status.textContent = 'Adding…';
      fetch(`${rootPath()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then((response) => {
        if (!response.ok) throw new Error('cart_add_failed');
        if (status) status.textContent = 'Added to cart ✓';
        setTimeout(() => window.location.reload(), 250);
      }).catch(() => {
        addButton.disabled = false;
        if (status) status.textContent = 'Could not add this size.';
      });
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-oss-qty-input]');
    if (!input) return;
    const line = input.dataset.line;
    let quantity = Math.max(1, Number(input.value) || 1);
    if (input.max) quantity = Math.min(quantity, Number(input.max));
    input.value = quantity;
    changeQuantity(line, quantity, input);
  });

  const fetchRecommendationMarkup = async (url) => {
    if (!url) return null;
    const response = await fetch(url, { headers: { 'Accept': 'text/html' } });
    if (!response.ok) return null;
    const html = await response.text();
    const shell = document.createElement('div');
    shell.innerHTML = html;
    return shell.querySelector('[data-oss-cart-recommendations]');
  };

  const loadRecommendations = async () => {
    const host = document.querySelector('[data-oss-cart-recommendations]');
    if (!host || host.querySelector('[data-oss-rec-card]')) return;

    let replacement = await fetchRecommendationMarkup(host.dataset.urlComplementary);
    if (!replacement || !replacement.querySelector('[data-oss-rec-card]')) {
      replacement = await fetchRecommendationMarkup(host.dataset.urlRelated);
    }

    if (replacement && replacement.querySelector('[data-oss-rec-card]')) {
      host.innerHTML = replacement.innerHTML;
    } else {
      host.hidden = true;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRecommendations, { once: true });
  } else {
    loadRecommendations();
  }

  document.addEventListener('shopify:section:load', loadRecommendations);
})();